import clsx from 'clsx'

import { AccountPerformanceOnDay, ApiAssociatedAccount, ApiPortfolioType } from '@/api/rtk-api'
import ChartIcon from '@/assets/chart-line.svg?react'
import { Link, Rule } from '@/components/core-v2'
import { PATH } from '@/const'

import { Last30DaysChart } from '../trades-table/Last30DaysChart'
import classes from './index.module.scss'

interface ExtendedTrade extends ApiAssociatedAccount {
  accountSource: string
  last30DaysPeformancePercent: number
  last30DaysPerformance: AccountPerformanceOnDay[]
  portfolioType: ApiPortfolioType
  strategyTemplateName: string
}
interface TradeProps {
  trade: ExtendedTrade
}

export const TradeOverview = ({ trade }: TradeProps) => {
  const isPositive = trade.last30DaysPeformancePercent >= 0
  const chartData = trade.last30DaysPerformance.map(
    day => [new Date(day.date).getTime(), day.value] as [number, number]
  )

  return (
    <>
      <div className={classes.infoWrapper}>
        <div className={classes.info}>
          <h5>Trade ID</h5>
          <span>{trade.accountId}</span>
        </div>
        <div className={classes.info}>
          <h5>Portfolio</h5>
          <span>{trade.portfolioType}</span>
        </div>
        <div className={classes.info}>
          <h5>Strategy</h5>
          <span>{trade.strategyTemplateName}</span>
        </div>
        <div className={clsx(classes.info, 'ml-auto')}>
          <h5>Last 7 days</h5>
          <span
            className={clsx({
              positive: isPositive,
              negative: !isPositive
            })}
          >
            {isPositive && '+'}
            {`${trade.last30DaysPeformancePercent.toFixed(2)}%`}
          </span>
        </div>
        <Last30DaysChart data={chartData} isPositive={isPositive} />
      </div>

      <Rule />
      <Link to={PATH.reportsSingleTradePerformance(trade.accountSource, trade.accountId)}>
        <ChartIcon />
        View trade report
      </Link>
    </>
  )
}
